import { eventHasRun } from '../../utils/eventTracker';

export const CLOSED = 'closed';
export const OPENED = 'opened';

function publishDialogAction(win, action, { timeStamp, target: element }) {
	let eventObject;

	if (action && [CLOSED, OPENED].includes(action)) {
		const eventType = `ddc.dialog.${action}`;

		if (
			!eventHasRun(eventType, {
				timeStamp
			})
		) {
			eventObject = {
				eventType,
				eventData: {
					element,
					pageName: win.DDC?.dataLayer?.page?.pageInfo?.pageName,
					dialogTitle: $(element)
						.closest('.ui-dialog')
						.find('.ui-dialog-title')
						.text()
						.trim()
				}
			};
		}
	}

	return eventObject;
}

export default publishDialogAction;
